export default class Content {
  id: any;
  relatedContentId: any;
  title: any;
  name: any;
  subtitle: any;
  img: any;
  type: any;
  status: 'READY' | 'COPYING' | 'ERROR' | 'DRAFT';
  epubName: any;
  pdfName: any;
  docName: any;
  mimeType: any;
  contentFileUrl: any;
  urlDownload: any;
  url: any;
  subtype: any;
  viewPage: any;
  contentFileHash: any;
  thumbnailMediumUrl: any;
  authorsNames: any;
  publisher: any;
  categoryNames: any;
  offset: any;
  numberOfPages: any;
  teacherOnly: any;
  pdfHash: any;
  pdfUrl: any;
  empty: any;
  owner: any;
  locked: any;
  fromId: any;
  classId: any;
  syncStatus: any;
  hasLocalBuilder: boolean;
  contentId: number; 
  version: any;
  builderId: number;
  deleteRemote: boolean;
  deleteLocal: boolean;
  
  constructor(contentInfo, baseUrl = '') {
    let { urlDownload, url, subtype, viewPage } = this.getInfo(contentInfo, baseUrl);
    this.id = contentInfo.id;
    this.relatedContentId = contentInfo.relatedContentId;
    this.title = contentInfo.title;
    this.name = contentInfo.name;
    this.subtitle = contentInfo.subtitle;
    this.img = contentInfo.img;
    this.type = contentInfo.type;
    this.status = contentInfo.status;
    this.epubName = contentInfo.epubName;
    this.pdfName = contentInfo.pdfName;
    this.docName = contentInfo.docName;
    this.mimeType = contentInfo.mimeType;
    this.contentFileUrl = contentInfo.contentFileUrl;
    this.urlDownload = urlDownload;
    this.url = url;
    this.subtype = subtype;
    this.viewPage = viewPage;
    this.contentFileHash = contentInfo.contentFileHash;
    this.thumbnailMediumUrl = contentInfo.thumbnailMediumUrl;
    this.authorsNames = contentInfo.authorsNames;
    this.publisher = contentInfo.publisher;
    this.categoryNames = contentInfo.categoryNames;
    this.offset = contentInfo.offset;
    this.numberOfPages = contentInfo.numberOfPages;
    this.teacherOnly = contentInfo.teacherOnly;
    this.pdfHash = contentInfo.pdfHash;
    this.pdfUrl = contentInfo.pdfUrl;
    this.empty = contentInfo.empty;
    this.owner = contentInfo.publisher;
    this.locked = contentInfo.locked;
    this.fromId = contentInfo.fromId;
    this.classId = contentInfo.classId;
    this.syncStatus = contentInfo.syncStatus;
    this.hasLocalBuilder = contentInfo.hasLocalBuilder ?? false;
    this.contentId = contentInfo.contentId;
    this.version = contentInfo.version;
    this.builderId = contentInfo.builderId;
    this.deleteRemote = contentInfo.deleteRemote;
    this.deleteLocal = contentInfo.deleteLocal;
  }

  get isReady() {
    return this.status === 'READY';
  }

  get isCopying() {
    return this.status === 'COPYING';
  }

  get hasError() {
    return this.status === 'ERROR';
  }

  getInfo(contentData, baseUrl) {
    let base = `${window.location.href.split(baseUrl)[0]}${baseUrl}/download/content/${contentData.id}`;
    let viewPage = `${baseUrl}/viewCourse?id=${contentData.id}`; 
    let subtype = null;
    let url = null;
    let urlDownload = `${base}/${contentData.pdfName}`;

    return { subtype, url, urlDownload, viewPage };
  }
  
}